<template>
    <LayoutSub className="business_unit">
        <SubSection classList="pb-0">
            <h1>
                1만여 대형 <strong class="c-red">법인가맹점 지원</strong> 및<br class="mo-only"> <strong class="c-red">신규 법인영업</strong>을 담당하는<br class="pc-only"/>
                <strong class="c-red">법인영업본부</strong>
            </h1>
            <p>
                법인영업본부는 단말기, POS 등 통합 결제솔루션에 대한 기술영업 전문조직으로, 영업 목표의 달성을 위해 특급호텔, 종합병원, 항공사,
                공공기관,<br class="pc-only"/>
                외식프렌차이즈 등의 대형 법인체를 대상으로 하는 직접적인 영업활동을 수행함으로써 수익 창출 및 시장점유율 증대에 가여하고 있습니다.<br />
                법인영업본부의 핵심 업무로는 영업 계획 수립 및, 영업전략 기획, 실적 분석 및 관리, 제안서 작성, 1만여 개의 법인 가맹점 지원 및 관리,
                신규 가맹점 영업 등을 담당합니다.<br />
                <br />
                한국정보통신 경쟁력의 핵심 법인영업본부에서는 도전적이고 창의적인 인재를 기다리겠습니다.
            </p>
            <img src="@/assets/corporate_sale_image01.png" alt="" />
        </SubSection>
        <SubSection classList="pt-160 pb-0">
            <h1>
                <strong class="c-red">제휴전략팀은</strong> 여러 분야의 파트너들과의 <strong class="c-red">상호 협력</strong>을 통해 <br />
                <strong class="c-red">혁신적인 솔루션을 제공</strong>하는 것을 목표로 합니다.
            </h1>
            <p>
                트렌드와 최신 기술에 대한 깊이 있는 분석을 통해 최적의 전략을 수립하고 KICC의 서비스 포트폴리오를 확장하여 풍부한 고객 경험을 제공하기
                위해 노력하고 있습니다. <br />
                미래 성장 동력을 파악하고 이를 기반으로 전략적 제휴 기회를 모색하며 서비스 확장 및 파트너사와 함께 지속 가능한 성장과 새로운 가치를
                창출함으로써 결제 시장에서의 발전에 앞장서고 있습니다.
            </p>
            <img src="@/assets/corporate_sale_image02.png" alt="" />
        </SubSection>
    </LayoutSub>
</template>
<script>
import SubSection from '@/components/SubSection.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
    },
};
</script>